import type {
  TDropdownMenuShortcutProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";
import { cn } from "@/ui/lib/utils";

export const DropdownMenuShortcut = ({
  className,
  ...props
}: TDropdownMenuShortcutProps) => (
  <span
    data-component="DropdownMenuShortcut"
    className={cn("ml-auto pl-8 text-sys-xs leading-sys-1-3 tracking-widest opacity-60", className)}
    {...props}
  />
);

DropdownMenuShortcut.displayName = "DropdownMenuShortcut";
